import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
interface PricingCardProps {
  title: string;
  subtitle: string;
  oldPrice: string;
  newPrice: string;
  ctaText: string;
  ctaLink: string;
  isPopular?: boolean;
  icon?: string;
}
export function PricingCard({
  title,
  subtitle,
  oldPrice,
  newPrice,
  ctaText,
  ctaLink,
  isPopular = false,
  icon = '📘'
}: PricingCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className={`relative bg-white rounded-2xl shadow-xl p-8 border-2 ${isPopular ? 'border-green-500' : 'border-gray-200'}`} data-id="element-247">
      {isPopular && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-green-500 text-white px-6 py-2 rounded-full font-bold text-sm shadow-lg" data-id="element-248">
          MÁS ELEGIDO
        </div>}

      <div className="text-center mb-6" data-id="element-249">
        <div className="text-4xl mb-3" data-id="element-250">{icon}</div>
        <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2" data-id="element-251">
          {title}
        </h3>
        <p className="text-gray-600 text-sm" data-id="element-252">{subtitle}</p>
      </div>

      <div className="text-center mb-6" data-id="element-253">
        <div className="text-gray-400 line-through text-lg mb-1" data-id="element-254">
          {oldPrice}
        </div>
        <div className="text-4xl md:text-5xl font-bold text-green-600" data-id="element-255">
          {newPrice}
        </div>
        <div className="text-sm text-gray-500 mt-1" data-id="element-256">ARS</div>
      </div>

      <a href={ctaLink} className={`block w-full text-center py-4 px-6 rounded-xl font-bold text-lg transition-all ${isPopular ? 'bg-green-600 hover:bg-green-700 text-white shadow-lg hover:shadow-xl' : 'bg-blue-600 hover:bg-blue-700 text-white shadow-lg hover:shadow-xl'}`} data-id="element-257">
        {ctaText}
      </a>
    </motion.div>;
}